// CRM 2.0 · M12 Template Builder: Make a copy — the new template's name (one pop-up style: Cancel and the action).
import React, { useState } from "react";
import cls from "./Templates.module.css";

function CopyTemplateModal({ version, onCancel, onConfirm }) {
  const [name, setName] = useState(`${version.templateName} (copy)`);
  const [busy, setBusy] = useState(false);
  async function go() {
    setBusy(true);
    try {
      await onConfirm(name.trim());
    } finally {
      setBusy(false);
    }
  }
  return (
    <div className={cls.mask} role="dialog" aria-modal="true" aria-label="Make a copy">
      <div className={cls.modal} style={{ maxWidth: "52rem" }}>
        <div className={cls.modalHead}>
          <h2>Make a copy of {version.templateName} v{version.versionNo}</h2>
          <p className={cls.hint}>
            A new template, Draft v1: the same Word file and every setting (blanks, sections, page fixes, buyer details).
            It is not linked to any project and needs its own approval.
          </p>
        </div>
        <div className={cls.modalBody}>
          <div>
            <label className={cls.lbl} htmlFor="copyName">New template name<sup>*</sup></label>
            <input id="copyName" className={cls.inp} value={name} autoFocus onChange={(e) => setName(e.target.value)}
              onKeyDown={(e) => { if (e.key === "Enter" && name.trim() && !busy) go(); }} />
          </div>
        </div>
        <div className={cls.modalFoot}>
          <button className={cls.btn} onClick={onCancel} disabled={busy}>Cancel</button>
          <button className={`${cls.btn} ${cls.primary}`} onClick={go} disabled={busy || !name.trim()}>{busy ? "Making a copy…" : "Make a copy"}</button>
        </div>
      </div>
    </div>
  );
}

export default CopyTemplateModal;
